// Cadre commun des pages hors accueil : même en-tête, même pied de page, même fond clair.
import React, { useEffect } from 'react';
import SiteHeader from '../../home/sections/SiteHeader';
import SiteFooter from '../../home/sections/SiteFooter';
import '../../home/home.css';

export const ACCENT = '#2347D6';

// Prise de rendez-vous en un clic, sans passer par le bas de l'accueil. utm_content dit quel bouton a servi
// (Calendly l'affiche dans le détail de chaque rendez-vous).
export const calendly = (from) => `https://calendly.com/hello-autoria/30min?utm_source=autoria.dev&utm_medium=site&utm_content=${from}`;
export const T = {
  ink: '#15171A',
  text: '#30353C',
  muted: '#4A5059',
  faint: '#5A6068',
  line: '#E3E5E8',
  line2: '#CDD1D6',
  ground: '#FBFBFA',
  soft: '#F1F4FF',
  sans: "'Archivo', 'Helvetica Neue', Helvetica, sans-serif",
  mono: "'IBM Plex Mono', ui-monospace, monospace"
};

export const styles = {
  container: { maxWidth: 1240, margin: '0 auto', padding: '0 24px' },
  narrow: { maxWidth: 760, margin: '0 auto', padding: '0 24px' },
  kicker: { margin: 0, fontFamily: T.mono, fontSize: 13, color: T.faint },
  h1: { margin: 0, fontSize: 'clamp(36px, 4.6vw, 60px)', fontWeight: 800, fontStretch: '78%', lineHeight: 1.0, letterSpacing: '-0.012em', textWrap: 'balance' },
  h2: { margin: 0, fontSize: 'clamp(26px, 2.8vw, 36px)', fontWeight: 800, fontStretch: '82%', lineHeight: 1.08 },
  lead: { margin: 0, fontSize: 19, color: T.text, lineHeight: 1.5 },
  button: { display: 'inline-flex', alignItems: 'center', minHeight: 52, boxSizing: 'border-box', padding: '14px 24px', background: ACCENT, color: '#FFFFFF', textDecoration: 'none', fontWeight: 700, fontSize: 17, borderRadius: 4 }
};

const SitePage = ({ children }) => {
  useEffect(() => {
    const previous = document.body.style.background;
    document.body.style.background = T.ground;
    return () => { document.body.style.background = previous; };
  }, []);
  return (
    <div style={{ background: T.ground, color: T.ink, fontFamily: T.sans, fontSize: 17, lineHeight: 1.5, minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <SiteHeader v={{ accent: ACCENT }} />
      <main style={{ flex: 1 }}>{children}</main>
      <SiteFooter v={{ accent: ACCENT }} />
    </div>
  );
};

// Bandeau d'appel final, repris sur les pages de contenu.
export const CallToAction = ({ title = 'Quel outil manque à votre équipe ?', text = '30 minutes sur le fichier qui vous coûte le plus de temps. Le prix fixe suit par écrit sous 3 jours.', from = 'page' }) => (
  <section style={{ background: ACCENT, color: '#FFFFFF', marginTop: 80 }}>
    <div style={{ ...styles.container, padding: '64px 24px', display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'space-between', gap: 24 }}>
      <div style={{ flex: '1 1 480px', minWidth: 0, display: 'flex', flexDirection: 'column', gap: 10 }}>
        <h2 style={{ ...styles.h2, color: '#FFFFFF' }}>{title}</h2>
        <p style={{ margin: 0, fontSize: 18 }}>{text}</p>
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 10, alignItems: 'flex-start' }}>
        <a href={calendly(from)} target="_blank" rel="noopener" className="lift" style={{ ...styles.button, background: '#FFFFFF', color: T.ink, fontWeight: 800 }}>Réserver un appel de 30 min</a>
        <a href="/diagnostic" style={{ color: '#FFFFFF', fontWeight: 600, fontSize: 15 }}>ou décrivez votre besoin en 1 minute</a>
      </div>
    </div>
  </section>
);

export default SitePage;
